/** field-service tools (v1.1) webhook shapes (docs/53 §6.3). See ./index.ts for the verification rule and the VERIFY note. */
import { z } from 'zod';
import { Email } from '../common.ts';

/** What the Jobber and Housecall Pro adapters normalise a "job completed" webhook into (VERIFY: each vendor's schema). */
export const FieldServiceJobCompleted = z.object({
  provider: z.enum(['jobber', 'housecall_pro']),
  externalJobId: z.string().max(128),
  completedAt: z.iso.datetime({ offset: true }),
  customer: z.object({ firstName: z.string().max(60), phone: z.string().max(32).nullable(), email: Email.nullable() }),
  serviceText: z.string().max(200).nullable(),
});
